//--------------------------------------------------------------------//
//******************** agentsTable ***********************************//
//--------------------------------------------------------------------//
// Renders the agents listing table and handles agent interactions.
// Displays agent name, model, and delete action per row.
// Clicking a row opens a full-screen popup with Info and Skills tabs.
// Delete action shows a confirmation dialog before removing the agent.
import './agents.scss';
import './agents.service.js';
import './agent-info/agent-info.tab.js';
import './agent-skills/agent-skills.service.js';
import './agent-skills/agent-skills.tab.js';
import './agent-tools/agent-tools.service.js';
import './agent-tools/agent-tools.tab.js';
import './agent-groups/agent-groups.tab.js';
import './agent-voice/agent-voice.service.js';
import './agent-voice/agent-voice.tab.js';
import './agent-scheduling/agent-scheduling.service.js';
import './agent-scheduling/agent-scheduling.tab.js';
import './agent-subscriptions/agent-subscriptions.service.js';
import './agent-subscriptions/agent-subscriptions.tab.js';
import './agent-ssh/agent-ssh.tab.js';
import './agent-logs/agent-logs.service.js';
import './agent-logs/agent-logs.tab.js';

angular.module('agentsTableModule')

    .directive('agentsTable', ['GhDialog', 'AgentsService', function (GhDialog, AgentsService) {
        return {
            restrict: 'E',
            scope: {
                agents: '='
            },

            controller: ['$scope', 'localizationService', function ($scope, localizationService) {
                const dictionary = localizationService.getDictionary('account_settings');
                $scope.translate = (word) => localizationService.translate(word, dictionary);

                if (!Array.isArray($scope.agents)) {
                    $scope.agents = [];
                }

                $scope.$watchCollection('agents', function (newValue) {
                    if (!Array.isArray(newValue)) {
                        $scope.agents = [];
                    }
                });

                // Opens a confirmation dialog to delete an agent. On confirm, calls the API and removes the agent from the list.
                $scope.showDeleteAgentPopup = function (agent) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'center',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            resizable: false,
                            content: `
                                <div class="delete_agent-popup">
                                    <div class="dialog-share-group">
                                        <span gh-icon="rubbish FF0D0D 65px"></span>
                                        <p class="dialog-share-group__title">Deleting Agent!</p>
                                    </div>

                                    <div class="dialog-share-group__content">
                                        <p class="info">
                                            Do you really want to delete this agent?
                                            You will not be able to restore it.
                                        </p>

                                        <div class="dialog-share-group__content__buttons">
                                            <button
                                                class="dialog-share-group__content__buttons__add btn btn-blue-reverse"
                                                ng-click="deleteAgent()"
                                            >
                                                Delete
                                            </button>

                                            <button
                                                class="dialog-share-group__content__buttons__cancel btn btn-blue"
                                                ng-click="cancel()"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            `
                        },
                        locals: {
                            agent
                        },
                        controller: [
                            '$scope',
                            'agent',
                            'AgentsService',
                            function ($scope, agent, AgentsService) {
                                $scope.deleteAgent = async function () {
                                    try {
                                        await AgentsService.delete({
                                            id: agent._id
                                        });

                                        if (!Array.isArray(tableScope.agents)) {
                                            tableScope.agents = [];
                                        }

                                        const index = tableScope.agents.findIndex(function (a) {
                                            return a._id === agent._id;
                                        });

                                        if (index !== -1) {
                                            tableScope.agents.splice(index, 1);
                                        }

                                        tableScope.$applyAsync();
                                        $scope.cancel();
                                    } catch (error) {
                                        console.log('Agent delete error:', error);
                                    }
                                };
                            }
                        ]
                    });
                };

                // Opens the full-screen agent detail popup with Info and Skills tabs.
                $scope.openAgent = function (e, agent) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'full',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            content: `
                                <div class="agent-popup">
                                    <div class="agent-popup__header">
                                        <div class="agent-popup__avatar">
                                            <gh-avatar gh-model="agent.gudhub_user_avatar" field-data-model="avatarFieldModel"></gh-avatar>
                                        </div>
                                        <div class="agent-name-wrapper">
                                            <div class="agent_name_input">{{agent.name}}</div>
                                        </div>

                                        <span
                                            class="close_dialog"
                                            ng-click="cancel()"
                                            gh-icon="cross #0D99FF 30px"
                                        ></span>
                                    </div>

                                    <div class="agent-popup__nav-panes">
                                    <div class="agent-popup__nav-track" ng-class="{'--detail_open': tabDetailOpen}">
                                    <div class="agent-popup__tabs">
                                        <div class="agent-popup__tab"
                                             ng-class="{'agent-popup__tab--active': activeTab === 'info'}"
                                             ng-click="activeTab = 'info'; tabDetailOpen = true;">
                                            {{translate('Agent Info')}}
                                            <span class="agent-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                        <div class="agent-popup__tab"
                                             ng-class="{'agent-popup__tab--active': activeTab === 'skills'}"
                                             ng-click="activeTab = 'skills'; tabDetailOpen = true;">
                                            {{translate('Skills')}}
                                            <span class="agent-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                        <div class="agent-popup__tab"
                                             ng-class="{'agent-popup__tab--active': activeTab === 'tools'}"
                                             ng-click="activeTab = 'tools'; tabDetailOpen = true;">
                                            {{translate('MCP')}}
                                            <span class="agent-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                        <div class="agent-popup__tab"
                                             ng-class="{'agent-popup__tab--active': activeTab === 'groups'}"
                                             ng-click="activeTab = 'groups'; tabDetailOpen = true;">
                                            {{translate('Groups')}}
                                            <span class="agent-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                        <div class="agent-popup__tab"
                                             ng-class="{'agent-popup__tab--active': activeTab === 'voice'}"
                                             ng-click="activeTab = 'voice'; tabDetailOpen = true;">
                                            {{translate('Voice')}}
                                            <span class="agent-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                        <div class="agent-popup__tab"
                                             ng-class="{'agent-popup__tab--active': activeTab === 'scheduling'}"
                                             ng-click="activeTab = 'scheduling'; tabDetailOpen = true;">
                                            {{translate('Scheduling')}}
                                            <span class="agent-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                        <div class="agent-popup__tab"
                                             ng-class="{'agent-popup__tab--active': activeTab === 'subscriptions'}"
                                             ng-click="activeTab = 'subscriptions'; tabDetailOpen = true;">
                                            {{translate('Subscriptions')}}
                                            <span class="agent-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                        <div class="agent-popup__tab"
                                             ng-class="{'agent-popup__tab--active': activeTab === 'ssh'}"
                                             ng-click="activeTab = 'ssh'; tabDetailOpen = true;">
                                            {{translate('SSH')}}
                                            <span class="agent-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                        <div class="agent-popup__tab"
                                             ng-class="{'agent-popup__tab--active': activeTab === 'logs'}"
                                             ng-click="activeTab = 'logs'; tabDetailOpen = true;">
                                            {{translate('Logs')}}
                                            <span class="agent-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                    </div>

                                    <div class="agent-popup__content-pane">
                                    <div class="agent-popup__mobile-header">
                                        <span class="agent-popup__mobile-back" ng-click="tabDetailOpen = false">
                                            <span gh-icon="arrow_left 0893d2 24px normal"></span>
                                        </span>
                                        <span ng-if="activeTab === 'info'">{{translate('Agent Info')}}</span>
                                        <span ng-if="activeTab === 'skills'">{{translate('Skills')}}</span>
                                        <span ng-if="activeTab === 'tools'">{{translate('MCP')}}</span>
                                        <span ng-if="activeTab === 'groups'">{{translate('Groups')}}</span>
                                        <span ng-if="activeTab === 'voice'">{{translate('Voice')}}</span>
                                        <span ng-if="activeTab === 'scheduling'">{{translate('Scheduling')}}</span>
                                        <span ng-if="activeTab === 'subscriptions'">{{translate('Subscriptions')}}</span>
                                        <span ng-if="activeTab === 'ssh'">{{translate('SSH')}}</span>
                                        <span ng-if="activeTab === 'logs'">{{translate('Logs')}}</span>
                                    </div>
                                    <div class="agent-popup__content">
                                        <div class="agent-info" ng-show="activeTab === 'info'">
                                            <agent-info-tab agent="agent" on-update="onAgentUpdate()"></agent-info-tab>
                                        </div>

                                        <div class="agent-skills" ng-show="activeTab === 'skills'">
                                            <agent-skills-tab agent="agent"></agent-skills-tab>
                                        </div>

                                        <div class="agent-tools-wrapper" ng-show="activeTab === 'tools'">
                                            <agent-tools-tab agent="agent"></agent-tools-tab>
                                        </div>

                                        <div class="agent-groups" ng-show="activeTab === 'groups'">
                                            <agent-groups-tab agent="agent"></agent-groups-tab>
                                        </div>

                                        <div class="agent-voice" ng-show="activeTab === 'voice'">
                                            <agent-voice-tab agent="agent"></agent-voice-tab>
                                        </div>

                                        <div class="agent-scheduling" ng-show="activeTab === 'scheduling'">
                                            <agent-scheduling-tab agent="agent"></agent-scheduling-tab>
                                        </div>

                                        <div class="agent-subscriptions" ng-show="activeTab === 'subscriptions'">
                                            <agent-subscriptions-tab agent="agent"></agent-subscriptions-tab>
                                        </div>

                                        <div class="agent-ssh" ng-show="activeTab === 'ssh'">
                                            <agent-ssh-tab agent="agent"></agent-ssh-tab>
                                        </div>

                                        <div class="agent-logs-wrapper" ng-show="activeTab === 'logs'">
                                            <agent-logs-tab agent="agent"></agent-logs-tab>
                                        </div>
                                    </div>
                                    </div>
                                    </div>
                                    </div>
                                </div>
                            `
                        },
                        locals: {
                            agent
                        },
                        controller: ['$scope', 'agent', 'localizationService', 'AgentsService', function ($scope, agent, localizationService, AgentsService) {
                            const dictionary = localizationService.getDictionary('account_settings');
                            $scope.translate = (word) => localizationService.translate(word, dictionary);
                            $scope.agent = agent;
                            $scope.activeTab = 'info';
                            $scope.tabDetailOpen = false;

                            $scope.avatarFieldModel = { image_size: 512, avatar_size: 100, uploadEvents: true };

                            if (agent.gudhub_user_id && !agent.gudhub_user_avatar) {
                                gudhub.getUserById(agent.gudhub_user_id).then(function (user) {
                                    if (user && user.avatar_512) {
                                        $scope.agent.gudhub_user_avatar = user.avatar_512;
                                        $scope.$applyAsync();
                                    }
                                });
                            }

                            $scope.$watch('agent.gudhub_user_avatar', function (newVal, oldVal) {
                                if (newVal && newVal !== oldVal && newVal.startsWith('data:')) {
                                    AgentsService.update({ agent_id: agent._id, gudhub_user_avatar: newVal });
                                }
                            });

                            $scope.onAgentUpdate = function () {
                                tableScope.$applyAsync();
                            };
                        }]
                    });
                };
            }],

            template: `
                <div class="listing_table">
                    <div class="listing_table_head_wrapper">
                        <div class="listing_table_column bottom_line w-50">
                            <div class="tab">{{translate('Name')}}</div>
                        </div>

                        <div class="listing_table_column w-35">
                            <div class="tab">{{translate('Model')}}</div>
                        </div>

                        <div class="listing_table_column w-15"></div>
                    </div>

                    <div class="listing_table_body_wrapper">
                        <div
                            class="listing_table_row"
                            ng-click="openAgent($event, agent)"
                            ng-repeat="agent in agents track by agent._id"
                        >
                            <div class="listing_table_column w-50">
                                <span class="number">{{$index + 1}}</span>
                                <div class="name">{{agent.name}}</div>
                            </div>

                            <div class="listing_table_column w-35">
                                <div class="name">{{agent.ai_model.model || 'N/A'}}</div>
                            </div>

                            <div class="listing_table_column w-15">
                                <span
                                    ng-click="showDeleteAgentPopup(agent); $event.stopPropagation()"
                                    class="delete_icon"
                                    gh-icon="rubbish 0d99ff 20px"
                                ></span>
                            </div>
                        </div>

                        <div ng-if="!agents.length" class="listing_table_nodata">
                            <p>{{translate('No Agents')}}</p>
                        </div>
                    </div>
                </div>
            `
        };
    }]);
